import TableContainer from "components/Common/TableContainer";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import { createSelector } from "reselect";
import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import ModalConfirm from "components/Common/ModalConfirm";
import { useRole } from "components/Hooks/UserHooks";
import CountUp from "react-countup";
import ModalPreview from "components/Common/ModalPreview";
import CollapseFilter from "components/Common/CollapseFilter";
import noImage1 from "../../../../assets/images/no-image-icon.png";
import { Link } from "react-router-dom";
import TooltipCustom from "components/Common/TooltipCustom";
import { IStaff } from "api/types/_staff";
import { formatDateStringToKorea } from "helpers/format";
import { getBarList } from "store/bar-list/thunk";
import barListApi from "api/barListApi";
import { Option } from "api/types/_public";
import { IFacility } from "api/types/_facility";
import userApi from "api/userApi";
import staffApi from "api/staffApi";
import { getTimeWorking } from "store/time-working/thunk";

export interface Tag {
  id: string;
  text: string;
}

registerLocale("en", en);
registerLocale("ko", ko);

export interface ISearch {
  page: number;
  limit: number;
  keyword: string;
}

const DEFAULT_DATA_SEARCH = {
  page: 1,
  limit: 30,
  keyword: "",
};

export interface IProps {
  lstStaff?: IStaff[],
  item?: any
}

const ConnectingList = ({
  item,
  lstStaff=[]
}: IProps) => {
  const { t, i18n } = useTranslation();
  const dispatch: any = useDispatch();
  const { userPermissions } = useRole();

  const noImage = useMemo(() => {
    return noImage1;
  }, []);

  const [queryTimeWorking, setQueryTimeWorking] = useState<ISearch>(DEFAULT_DATA_SEARCH)

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [itemToDelete, setItemToDelete] = useState<any>(false);
  const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);
  const [itemToEdit, setItemToEdit] = useState<any>(false);
  const [linkImage, setLinkImage] = useState<string>("");

  const [listBarOption, setListBarOption] = useState<Option[]>([]);
  const [listUsersOption, setListUsersOption] = useState<Option[]>([]);

  const [keywordSearch, setKeywordSearch] = useState<string>("");

  const selectLayoutState = (state: any) => state.TimeWorking;

  const TimeWorkingProperties = createSelector(selectLayoutState, (state) => {
    return  ({
      lstTimeWorking: state.lstTimeWorking1,
      isTimeWorkingLoading: state.isTimeWorkingLoading,
      isTimeWorkingSuccess: state.isTimeWorkingSuccess,
  
      error: state.error,
    })
  });

  // Inside your component
  const { lstTimeWorking, isTimeWorkingLoading } = useSelector(TimeWorkingProperties);

  function loadTableData(queryData?: ISearch) {
    const dataSearch = queryData ? queryData : queryTimeWorking
    dispatch(getTimeWorking(dataSearch));
  }

  useEffect(() => {
    loadTableData();
  }, [dispatch]);

  const searchData = () => {
    loadTableData(queryTimeWorking);
  };

  const resetData = () => {
    setQueryTimeWorking(DEFAULT_DATA_SEARCH);
    setKeywordSearch((_prev) => "");
    loadTableData(DEFAULT_DATA_SEARCH);
  };

  const handleChangeKeyword = (value: string) => {
    setKeywordSearch(value)
    setQueryTimeWorking({
      ...queryTimeWorking,
      keyword: value
    })
  }
  // Begin::Update User
  const onCloseClick = () => {
    setItemToEdit((_prev: any) => null);
    setIsOpen((_prev) => false);
  };
  //End::Update User

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t("No."),
        thWidth: 80,
        Cell: ({ ...props }) => {
          return (
            <div>
              {lstTimeWorking?.meta?.total -
                ((queryTimeWorking?.page - 1) * queryTimeWorking?.limit + props?.row?.index)}
            </div>
          );
        },
      },
      {
        Header: t("Image"),
        accessor: "image",
        thClass: "text-center",
        filterable: true,
        sortable: false,
        thWidth: 120,
        Cell: (cell: any) => {
          const image = cell?.row?.original?.staff?.profile_image_url;

          return image ? (
            <>
              <div className="w-100 text-center " style={{ minWidth: "120px" }}>
                <div
                  style={{ width: "80px" }}
                  className="m-auto cursor-pointer"
                  onClick={() => setLinkImage((prev) => image)}
                >
                  <img
                    src={image}
                    className="flex-shrink-0 w-100"
                    alt="thumbnail"
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null; // prevents looping
                      currentTarget.src = noImage;
                    }}
                  />
                </div>
              </div>
            </>
          ) : (
            ""
          )
        }
      },
      {
        Header: t("Name"),
        accessor: "name",
        filterable: true,
        sortable: false,
        Cell: (cell: any) => {
          const nickName = cell?.row?.original?.staff?.nick_name;

          return (
            <>
              <div className="cursor-pointer">
                {nickName}
              </div>
            </>
          );
        },
      },
      {
        Header: t("Gender"),
        accessor: "gender",
        filterable: true,
        sortable: false,
        Cell: (cell: any) => {
          const gender = cell?.row?.original?.staff?.gender;

          return (
            <>
              <div className="cursor-pointer">
                {gender}
              </div>
            </>
          );
        },
      },
      {
        Header: t("Phone Number"),
        accessor: "phone_number",
        filterable: true,
        sortable: false,
        Cell: (cell: any) => {
          const phoneNumber = cell?.row?.original?.staff?.phone_number;

          return (
            <>
              <div className="cursor-pointer">
                {phoneNumber}
              </div>
            </>
          );
        },
      },
      {
        Header: t("Date Connect"),
        accessor: "date_connecting",
        filterable: true,
        sortable: false,
        thClass: "text-end",
        Cell: (cell: any) => {
          const breakEndTime = cell?.row?.original?.staff?.date_connecting;
          const date = formatDateStringToKorea(breakEndTime);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "120px" }}>
              {cell?.value ? (
                <span>
                  <span>{arrDate?.[0] || ""}</span> <br />{" "}
                  <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
                </span>
              ) : (
                "-"
              )}
            </div>
          );
        },
      },
      {
        Header: t("Button Action"),
        thClass: "text-center",
        thWidth: 150,
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <ul
              className="list-inline d-flex flex-wrap hstack gap-2 mb-0"
              style={{ width: "150px", justifyContent: "center" }}
            >
              <TooltipCustom
                title={t("Button Update")}
                id={`update-md-${item?.id}`}
              >
                <li className="list-inline-item" id={`update-md-${item?.id}`}>
                  <Link
                    className="btn btn-sm btn-soft-primary edit-item-btn"
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                      setItemToEdit(item);
                      setIsOpen(false);
                    }}
                  >
                    <i className="ri-pencil-fill align-bottom "></i>
                  </Link>
                </li>
              </TooltipCustom>

              <TooltipCustom
                title={t("Button Delete")}
                id={`delete-md-${item?.id}`}
              >
                <li className="list-inline-item" id={`delete-md-${item?.id}`}>
                  <Link
                    className="btn btn-sm btn-soft-danger edit-item-btn"
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                      setItemToDelete(item);
                    }}
                  >
                    <i className="ri-delete-bin-3-fill align-bottom"></i>
                  </Link>
                </li>
              </TooltipCustom>
            </ul>
          );
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [i18n?.language, lstTimeWorking?.meta?.total]
  );

  const handleChangePage = useCallback((page: any) => {
    setQueryTimeWorking({ ...queryTimeWorking, page: page + 1 });
    loadTableData({ ...queryTimeWorking, page: page + 1 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onCloseImageClick = () => {
    setLinkImage((_prev) => "");
  };
  // Begin::Delete

  const handleActionDelete = async (id: any) => {
    if (!id) {
      return;
    }
    try {
      setIsConfirmLoading((_prev) => true);
      const response: any = await staffApi?.deleteStaff(id);
      
      if (response?.data) {
        loadTableData();
        setIsConfirmLoading((_prev) => false);
        setItemToDelete(false);
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        setIsConfirmLoading((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsConfirmLoading((_prev) => false);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const triggerRefresh = () => {
    setItemToEdit(null);
    onCloseClick();
    loadTableData();
  };

  useEffect(() => {
    const handleCallAllOption = async () => {
      try {
        const [resBarList, resUserList]: any = await Promise.all([barListApi.bars({ limit: 2000 }), userApi.users({ page: 1, limit: 2000 })]);

        if(resBarList?.data?.list) {
          const resDataBar = resBarList?.data?.list;
          setListBarOption(
            resDataBar?.map((item: any) => {
              return {
                label: item?.title,
                value: item?.id
              }
            })
          )
        }

        if(resUserList?.data?.list) {
          const resDataUsers = resUserList?.data?.list;
          setListUsersOption(
            resDataUsers?.map((item: any) => {
              return {
                label: item?.title,
                value: item?.id,
                data: item
              }
            })
          )
        }
      } catch (error: any) {

        return error;
      }
    };

    handleCallAllOption();
  }, []);

  // End::Delete
  useEffect(() => {
    document.title = `${t("Time Working")} - ${t("Store List")} | Baive`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <div className="mt-3">
        <Container fluid>
          <Row>
            <Col lg={12}>
              <Card
                id="customerList"
                style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
              >
                <CardHeader className="border-0">
                  <Row className="g-4 align-items-center">
                    <div className="col-sm">
                      <div>
                        <h5 className="card-title mb-0">
                          <span className="me-2">{t("Total")}:</span>
                          <CountUp
                            start={0}
                            end={lstTimeWorking?.meta?.total || 0}
                            duration={1}
                            className="text-primary"
                          />
                        </h5>
                      </div>
                    </div>
                  </Row>
                </CardHeader>
                <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                  <CollapseFilter>
                    <Row className="g-4 align-items-center mt-0 mt-md-2">
                      {/* <Col
                        sm={12}
                        md={12}
                        xl={12}
                        xxl={12}
                        className="hstack gap-1 justify-content-center justify-content-md-end mt-4 mt-md-2"
                      >
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary me-1"
                            onClick={searchData}
                          >
                            <i className="ri-search-line align-bottom me-1"></i>{" "}
                            {t("Button Search")}
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary fs-14"
                            onClick={resetData}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                            {t("Button Reset")}
                          </button>
                        </div>
                      </Col> */}
                    </Row>
                  </CollapseFilter>
                </div>
                <CardBody className="pt-3">
                  <div>
                    <TableContainer
                      className="custom-header-css"
                      divClass="table-responsive table-card"
                      tableClass="align-middle table-bordered-dashed"
                      theadClass="table-light text-muted"
                      columns={columns}
                      data={lstTimeWorking?.list?.length ? lstTimeWorking?.list : []}
                      customPageSize={queryTimeWorking.limit}
                      customPageIndex={queryTimeWorking.page - 1}
                      totalRecords={lstTimeWorking?.meta?.total}
                      customPageCount={Math.ceil(
                        Number(lstTimeWorking?.meta?.total) / Number(queryTimeWorking.limit)
                      )}
                      handleChangePage={handleChangePage}
                      manualSorting={true}
                      // sorting={{
                      //   sort_by: queryTimeWorking.sort_by,
                      //   order_by: queryTimeWorking.order_by,
                      // }}
                      // handleChangeSorting={handleChangeSorting}
                      isLoading={isTimeWorkingLoading}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        {itemToDelete && (
          <ModalConfirm
            header={t("Delete Time Working")}
            isOpen={itemToDelete}
            isLoading={isConfirmLoading}
            onClose={() => setItemToDelete(false)}
            onConfirm={() => handleActionDelete(itemToDelete?.id)}
          />
        )}

        <ModalPreview
          type={"IMAGE"}
          isOpen={!!linkImage}
          url={linkImage}
          onClose={() => onCloseImageClick()}
        />

        {/* <Modal
          isOpen={isModalArtist}
          id="artist-modal"
          centered
          size="xl"
          scrollable={true}
          // toggle={onCloseDetailCategoryClick}
          keyboard={true}
        >
          <ModalHeader toggle={()=> setIsModalArtist(false)}>
            {t("Keywords")}
          </ModalHeader>
          <ModalBody className="text-center">
            <div
              className="row g-4"
              style={{ minHeight: "calc(100dvh - 200px)" }}
            >
              <TrendIndexKeyword
                detailCategory={detailCategoryLoading || undefined}
                handleRefreshListCategory={handleRefetchCategoriesTrendIndex}
              />
            </div>
          </ModalBody>
        </Modal> */}
      </div>
    </React.Fragment>
  );
};

export default ConnectingList;
